/**
 * @generated SignedSource<<b2bee315a325c083b960b989351fdfcb>>
 * @relayHash bd8387ca03f8f8be61b794345955a145
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3afd564b1cf410051529fc2870c09ed93af45a2924c178c12b51ba94a67e8025

import type { ConcreteRequest } from 'relay-runtime';
export type RecentFilter = "ALL" | "COLLABORATED_ON" | "CREATED" | "WORKED_ON" | "%future added value";
export type useRecentPreferencesHomeRecentUserPreferencesMutation$variables = {
  filter?: RecentFilter | null | undefined;
};
export type useRecentPreferencesHomeRecentUserPreferencesMutation$data = {
  readonly updateUserPreferences: {
    readonly recentFilter: RecentFilter;
  } | null | undefined;
};
export type useRecentPreferencesHomeRecentUserPreferencesMutation = {
  response: useRecentPreferencesHomeRecentUserPreferencesMutation$data;
  variables: useRecentPreferencesHomeRecentUserPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "recentFilter",
            "variableName": "filter"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "recentFilter"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRecentPreferencesHomeRecentUserPreferencesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRecentPreferencesHomeRecentUserPreferencesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bd8387ca03f8f8be61b794345955a145",
    "id": "3afd564b1cf410051529fc2870c09ed93af45a2924c178c12b51ba94a67e8025",
    "metadata": {},
    "name": "useRecentPreferencesHomeRecentUserPreferencesMutation",
    "operationKind": "mutation",
    "text": "mutation useRecentPreferencesHomeRecentUserPreferencesMutation($filter:RecentFilter){updateUserPreferences(userPreferences:{recentFilter:$filter}){recentFilter}}"
  }
};
})();

(node as any).hash = "2fdd04d3acfc9c6d79d5520f675998c5";

export default node;
